import { ISOStringStorageLuxonDateTimeT, LuxonDurationT } from './Luxon';
import * as T from 'io-ts';
import { fromNullable } from 'io-ts-types';
export const ResultT = T.type({
    red: T.number,
    amber: T.number,
    green: T.number,
    date: ISOStringStorageLuxonDateTimeT,
    card: T.string,
    deleted: fromNullable(T.boolean, false),
});
export const ResultArrayT = T.array(ResultT);
export const ResultWithOffsetT = T.type({
    red: T.number,
    amber: T.number,
    green: T.number,
    offset: LuxonDurationT,
    card: T.string,
    deleted: T.boolean,
});
